<template>
    <div class="hrdate">
        <hr>
        <div class="hrdate_date">{{date}}</div>
    </div>
</template>

<script>
export default {
    props: ['date']
}
</script>

<style lang="scss" scoped>
.hrdate{
    position: relative;
    margin: 1rem 0;
    color: #BDBDBD;
    height: 35px;
    padding: 2px;
    font-size: 1rem;
    .hrdate_date{
        position: absolute;
        width: 150px;
        left: calc(50% - 75px);
        top: calc(-0.1rem + 6px);
        padding: .1rem;
        background: #193242;
        text-align: center;
        border-radius: 30px;
    }
}
</style>
